import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import './Login.css';

function Login() {
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [localeOpen, setLocaleOpen] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    
    if (login(username, password)) {
      navigate('/dashboard/KR');
    } else {
      setError('아이디 또는 비밀번호가 올바르지 않습니다.');
    }
  };

  return (
    <div className="login-page">
      <div className="login-header">
        <div className="supplier-hub-logo">
          <img 
            src="https://img1a.coupangcdn.com/image/coupang/retail/common/logo/supplier-hub-logo.svg" 
            alt="logo" 
            height="32"
          />
        </div>
        
        <div className="dropdown">
          <button 
            type="button" 
            className={`rs-locales dropdown-toggle btn btn-light ${localeOpen ? 'show' : ''}`}
            onClick={() => setLocaleOpen(!localeOpen)}
          >
            <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm7.5-6.923c-.67.204-1.335.82-1.887 1.855A7.97 7.97 0 0 0 5.145 4H7.5V1.077zM4.09 4a9.267 9.267 0 0 1 .64-1.539 6.7 6.7 0 0 1 .597-.933A7.025 7.025 0 0 0 2.255 4H4.09zm-.582 3.5c.03-.877.138-1.718.312-2.5H1.674a6.958 6.958 0 0 0-.656 2.5h2.49zM4.847 5a12.5 12.5 0 0 0-.338 2.5H7.5V5H4.847zM8.5 5v2.5h2.99a12.495 12.495 0 0 0-.337-2.5H8.5zM4.51 8.5a12.5 12.5 0 0 0 .337 2.5H7.5V8.5H4.51zm3.99 0V11h2.653c.187-.765.306-1.608.338-2.5H8.5zM5.145 12c.138.386.295.744.468 1.068.552 1.035 1.218 1.65 1.887 1.855V12H5.145zm.182 2.472a6.696 6.696 0 0 1-.597-.933A9.268 9.268 0 0 1 4.09 12H2.255a7.024 7.024 0 0 0 3.072 2.472zM3.82 11a13.652 13.652 0 0 1-.312-2.5h-2.49c.062.89.291 1.733.656 2.5H3.82zm6.853 3.472A7.024 7.024 0 0 0 13.745 12H11.91a9.27 9.27 0 0 1-.64 1.539 6.688 6.688 0 0 1-.597.933zM8.5 12v2.923c.67-.204 1.335-.82 1.887-1.855.173-.324.33-.682.468-1.068H8.5zm3.68-1h2.146c.365-.767.594-1.61.656-2.5h-2.49a13.65 13.65 0 0 1-.312 2.5zm2.802-3.5a6.959 6.959 0 0 0-.656-2.5H12.18c.174.782.282 1.623.312 2.5h2.49zM11.27 2.461c.247.464.462.98.64 1.539h1.835a7.024 7.024 0 0 0-3.072-2.472c.218.284.418.598.597.933zM10.855 4a7.966 7.966 0 0 0-.468-1.068C9.835 1.897 9.17 1.282 8.5 1.077V4h2.355z"></path>
            </svg>
            <span>한국어</span>
          </button>
        </div>
      </div>

      <main className="rs-login">
        <div className="login-container">
          <img 
            height="50" 
            src="https://img1a.coupangcdn.com/image/coupang/retail/common/logo/supplier-hub-logo.svg" 
            alt="logo"
            className="login-logo"
          />
          
          <form onSubmit={handleSubmit} className="re-login-form">
            {error && <div className="error-message">{error}</div>}
            
            <label>
              <span className="rs-pre-icon">
                <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"></path>
                </svg>
              </span>
              <input 
                required 
                type="text" 
                name="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="form-control" 
                placeholder="ID를 입력해주세요."
              />
            </label>
            
            <label>
              <span className="rs-pre-icon">
                <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 14 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" d="M12.83 2.17C12.08 1.42 11.14 1.03 10 1c-1.13.03-2.08.42-2.83 1.17S6.04 3.86 6.01 5c0 .3.03.59.09.89L0 12v1l1 1h2l1-1v-1h1v-1h1v-1h2l1.09-1.11c.3.08.59.11.91.11 1.14-.03 2.08-.42 2.83-1.17S13.97 6.14 14 5c-.03-1.14-.42-2.08-1.17-2.83zM11 5.38c-.77 0-1.38-.61-1.38-1.38 0-.77.61-1.38 1.38-1.38.77 0 1.38.61 1.38 1.38 0 .77-.61 1.38-1.38 1.38z"></path>
                </svg>
              </span>
              <input 
                required 
                name="password" 
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form-control" 
                placeholder="비밀번호를 입력 해주세요"
              />
              <span className="rs-suf-icon" onClick={togglePasswordVisibility}>
                <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                  <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z"></path>
                  <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z"></path>
                </svg>
              </span>
            </label>
            
            <section className="forget-link">
              <a href="/auth/find-uid">아이디 찾기</a>
              <a href="/auth/find-pwd">비밀번호 찾기</a>
            </section>
            
            <input type="hidden" name="credentialId" value="" />
            <button type="submit" className="btn btn-primary">로그인</button>
          </form>
          
          <div className="rs-reset">
            <span className="reset-legend">새로운 공급업체인가요?</span>
            <button type="button" className="btn btn-light">가입하기</button>
          </div>
        </div>
      </main>

      <footer className="supplier-hub-footer">
        <div className="footer-left">
          <div className="footer-contact">서플라이어 콜센터 : 1600-9879 (월-금 9:00-19:00)</div>
          <div className="footer-copyright">© Copyright 2022 Coupang.com, or its affiliates. All rights reserved.</div>
        </div>
        <div className="footer-links">
          <a href="#" target="_blank" rel="noreferrer">이용약관</a>
          <span className="separator">|</span>
          <a href="#" target="_blank" rel="noreferrer" className="privacy">개인정보 처리방침</a>
          <span className="separator">|</span>
          <a href="#" rel="noreferrer">온라인 문의</a>
          <span className="separator">|</span>
          <a href="#" rel="noreferrer">나의 문의내역</a>
        </div>
      </footer>
    </div>
  );
}

export default Login;
